import React, { useState, useEffect, useMemo } from 'react';
import AdyenCheckout from '@adyen/adyen-web';
import isEmpty from 'lodash/isEmpty';
import { getTemplateString } from 'common/helpers/string';
import DateSelector from 'components/DateSelector/DateSelector';
import Tabs from 'components/Tabs/Tabs';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import Tooltip from 'components/Tooltip/Tooltip';
import styles from './PaymentMethodForm.module.scss';
import { useHistory } from 'react-router-dom';
import http from 'app/http';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import { useAppSelector } from 'app/hooks';
import { selectCurrentMarket } from 'features/core/selectors';
import { Market } from 'common/consts/markets';
import { setContent } from 'features/content/reducer';
import PageLink from 'components/PageLink/PageLink';
import { getPaymentConfig } from 'common/helpers/payments';
import classNames from 'classnames/bind';
import RepaymentList from 'components/RepaymentList/RepaymentList';
import { createTrue } from 'typescript';
import { formProgression } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
}

const PaymentMethodForm = ({ PageData, Model }: Props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [
    changedSelectedPaymentMethodType,
    setchangedSelectedPaymentMethodType,
  ] = useState(Model.FormModel.SelectedPaymentMethodType);
  const [changedSelectedFirstPaymentDate, setChangedSelectedFirstPaymentDate] =
    useState(Model.FormModel.SelectedFirstPaymentDate);
  const [validateModel, setvalidateModel] = useState(false);
  const imgsrc = getTemplateString('/images/icons/payment/{itemType}.png');
  const locale = PageData?.Language;
  const [canApplePay, setCanApplePay] = useState<boolean>(false);
  const [canGooglePay, setCanGooglePay] = useState<boolean>(false);
  const [isManualPayment, setIsManualPayment] = useState<boolean>(false);
  const [isScheduledRepayment, setIsScheduledRepayment] =
    useState<boolean>(false);
  const [scheduledRepayment, setScheduledRepayment] = useState<any>();
  const paymentConfig = useMemo(() => getPaymentConfig(Model), [Model]);
  const currentMarket = useAppSelector(selectCurrentMarket);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checkoutObj, SetcheckoutObj] = useState<any>(null);
  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };

  const assignManualHeadAndToolTip = () => {
    return (
      <div className={styles.displayflex}>
        {PageData?.ManualPaymentMethodsHeader}
        {(!isNullOrWhiteSpace(PageData?.AutomatedPaymentTooltipInformation) ||
          !isNullOrWhiteSpace(PageData?.ManualPaymentTooltipInformation)) && (
          <Tooltip id="PaymentTooltipInformationTooltip">
            <strong>{PageData?.AutomatedPaymentTooltipHeader}</strong>
            {PageData?.AutomatedPaymentTooltipInformation}

            <strong>{PageData?.ManualPaymentTooltipHeader}</strong>
            {PageData?.ManualPaymentTooltipInformation}
          </Tooltip>
        )}
      </div>
    );
  };

  const tabsLabels = useMemo(() => {
    const labels = [];
    if (!isEmpty(Model.AutomatedPaymentMethods)) {
      labels.push(PageData?.AutomatedPaymentMethodsHeader);
    }
    if (!isEmpty(Model?.ManualPaymentMethods)) {
      labels.push(assignManualHeadAndToolTip());
    }
    return labels;
  }, [Model?.AutomatedPaymentMethods, Model?.ManualPaymentMethods]);

  let availableDates: Date[] = [];
  let dateFormat: string = 'dd/MM/yyyy';
  const [isDisabled, setisDisabled] = useState(
    Model.FormModel.SelectedPaymentMethodType === null,
  );

  function changePaymentMethodType(e: any, isManualPayment: boolean) {
    setisDisabled(false);
    setchangedSelectedPaymentMethodType(e.target.value);
    setIsManualPayment(isManualPayment);
  }

  function changeDate(e: any) {
    setvalidateModel(false);
    setChangedSelectedFirstPaymentDate(e);
    if (
      currentMarket === Market.NL ||
      currentMarket === Market.BE ||
      currentMarket === Market.PL ||
      (currentMarket === Market.DE && !Model?.ForOffer)
    )
      onSubmitDate(e);
  }

  if (!isNullOrWhiteSpace(Model.MarketShortDateFormat)) {
    dateFormat = Model.MarketShortDateFormat;
  }

  async function adyenDropinCheckout(config: any) {
    try {
      if (checkoutObj == null) {
        let resCheckout = await AdyenCheckout(config).then((response) => {
          return response;
        });
        SetcheckoutObj(resCheckout);

        if (resCheckout) {
          const googlepay = resCheckout.create('paywithgoogle');

          googlepay
            .isAvailable()
            .then(() => {
              setCanGooglePay(true);
            })
            .catch(() => {
              setCanGooglePay(false);
            });

          const applepay = resCheckout.create('applepay');

          applepay
            .isAvailable()
            .then(() => {
              setCanApplePay(true);
            })
            .catch(() => {
              setCanApplePay(false);
            });
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    adyenDropinCheckout(paymentConfig);
  }, [paymentConfig, Model]);

  const automatedPaymentMethod = Model.AutomatedPaymentMethods.map(
    (AutomatedPaymentMethod: {
      ElementId: any;
      Type: any;
      Selected: any;
      CssClass: any;
      Name: any;
    }) => {
      const itemImageSrc =
        imgsrc &&
        `${process.env.PUBLIC_URL}${imgsrc({
          itemType: AutomatedPaymentMethod.Type,
        })}`;
      if (
        (AutomatedPaymentMethod.Type === 'paywithgoogle' && !canGooglePay) ||
        (AutomatedPaymentMethod.Type === 'applepay' && !canApplePay)
      ) {
        return null;
      }
      return (
        <label
          id={'wrap_' + AutomatedPaymentMethod.ElementId}
          key={AutomatedPaymentMethod.ElementId}
          className="paymentOptions__label"
        >
          <input
            type="radio"
            name={Model.FormModel.SelectedPaymentMethodType}
            id={AutomatedPaymentMethod.ElementId}
            value={AutomatedPaymentMethod.Type}
            checked={
              AutomatedPaymentMethod.Type === changedSelectedPaymentMethodType
            }
            className={styles.paymentinput}
            onChange={(e) => changePaymentMethodType(e, false)}
            onBlur={(e) => {
              formProgression(
                e,
                'ChoosePaymentMethodForm',
                'SelectedPaymentMethod',
              );
            }}
          />
          <span className={styles.customInput}>
            <img
              src={itemImageSrc}
              className={AutomatedPaymentMethod.CssClass}
            />
          </span>
          {AutomatedPaymentMethod.Name}
        </label>
      );
    },
  );

  const manualPaymentMethod = Model.ManualPaymentMethods.map(
    (ManualPaymentMethod: {
      ElementId: any;
      Type: any;
      Selected: any;
      CssClass: any;
      Name: any;
    }) => {
      const itemImageSrc =
        imgsrc &&
        `${process.env.PUBLIC_URL}${imgsrc({
          itemType: ManualPaymentMethod.Type,
        })}`;
      if (
        (ManualPaymentMethod.Type === 'manualpaywithgoogle' && !canGooglePay) ||
        (ManualPaymentMethod.Type === 'manualApplePay' && !canApplePay)
      ) {
        return null;
      }
      return (
        <label
          id={'wrap_' + ManualPaymentMethod.ElementId}
          key={ManualPaymentMethod.ElementId}
          className="paymentOptions__label"
        >
          <input
            type="radio"
            name={Model.FormModel.SelectedPaymentMethodType}
            id={ManualPaymentMethod.ElementId}
            value={ManualPaymentMethod.Type}
            checked={
              ManualPaymentMethod.Type == changedSelectedPaymentMethodType
            }
            className={styles.paymentinput}
            onChange={(e) => changePaymentMethodType(e, true)}
            onBlur={(e) => {
              formProgression(
                e,
                'ChoosePaymentMethodForm',
                'SelectedPaymentMethod',
              );
            }}
          />
          <span className={styles.customInput}>
            <img src={itemImageSrc} className={ManualPaymentMethod.CssClass} />
          </span>
          {ManualPaymentMethod.Name}
        </label>
      );
    },
  );

  (Model.PaymentDates || []).map(
    (paymentDateViewModel: {
      Selected: any;
      Date: any;
      AllowedPaymentMethods: any;
    }) =>
      paymentDateViewModel.AllowedPaymentMethods.split(',').indexOf(
        changedSelectedPaymentMethodType,
      ) >= 0 && availableDates.push(new Date(paymentDateViewModel.Date)),
  );

  const onSubmitDate = async (paymentDate: any) => {
    try {
      setIsLoading(true);
      const response = await http.post(
        Model.ChoosePaymentMethodPagePageUrl,
        // Convert object into string
        qs.stringify({
          'FormModel.SelectedPaymentMethodType':
            changedSelectedPaymentMethodType,
          'FormModel.SelectedFirstPaymentDate': paymentDate,
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );
      if (response && response.data) {
        setScheduledRepayment(response.data);
        setIsScheduledRepayment(true);
        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  const formSubmit = async (e: any) => {
    e.preventDefault();
    try {
      if (
        changedSelectedFirstPaymentDate == null ||
        changedSelectedFirstPaymentDate == ''
      ) {
        setvalidateModel(true);
        return;
      }
      const response = await http.post(
        Model.ConfirmPaymentMethodPageUrl,
        // Convert object into string
        qs.stringify({
          'FormModel.SelectedPaymentMethodType':
            changedSelectedPaymentMethodType,
          'FormModel.SelectedFirstPaymentDate': changedSelectedFirstPaymentDate,
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );
      if (response && response.data) {
        var nextPagePath = '';
        if (!response.data.RedirectUrl) {
          // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
          nextPagePath = getPathnameFromUrl(Model.ConfirmPaymentMethodPageUrl);
          // Add response to store
          dispatch(setContent({ [nextPagePath]: response.data }));
        } else {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
        }

        // Redirect to next step path
        history.push(nextPagePath, {
          noRefresh: false,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form onSubmit={formSubmit}>
      <section className="CreateRepaymentPlan__section">
        <div className="Tabs tabsPayment">
          <div>
            {
              <div className="paymentOptions">
                <h5 className="paymentOptions__heading">
                  {PageData?.PaymentMethodsHeader}
                </h5>
                <div className="paymentOptions__wrapper">
                  {automatedPaymentMethod}
                  {manualPaymentMethod}
                </div>
                {isManualPayment && (
                  <div className={styles.manual_error}>
                    <h3 className={classNames(styles.heading, 'manual_icon')}>
                      {PageData?.ManualPaymentInfoHeader}
                    </h3>
                    <p className={styles.text}>
                      {PageData?.ManualPaymentInfoText}
                    </p>
                  </div>
                )}
              </div>
            }
          </div>
        </div>
      </section>
      {validateModel && (
        <section className="CreateRepaymentPlan__section">
          <span className="u-textCenter u-marginBxsm u-block u-colorTextRed">
            {PageData?.PaymentMethodOrDateNotSelectedError}
          </span>
        </section>
      )}

      <section className="CreateRepaymentPlan__section">
        <div className="CreateRepaymentPlan__paymentDate">
          <h5 className="CreateRepaymentPlan__sectionHeading">
            {PageData?.FirstPaymentDateLabel}
          </h5>
          <DateSelector
            className={classNames(
              'Datepicker-input ',
              styles.datepicker,
              isDisabled && styles.disabled,
            )}
            date={changedSelectedFirstPaymentDate}
            placeholder={PageData.SelectDatePlaceholderText}
            calendarStartDay={1}
            onChange={(e) => changeDate(e)}
            onBlur={(e) =>
              formProgression(
                e,
                'ChoosePaymentMethodForm',
                'SelectedFirstPaymentDate',
              )
            }
            locale={locale}
            includeDates={availableDates}
          ></DateSelector>
        </div>
      </section>
      {isLoading && (
        <section className="CreateRepaymentPlan__section">
          <div className="Modal-loader-Paymentplan">
            <img
              className="Modal-loaderIcon"
              src="/assets/images/icons/loader/loader.gif"
            />
          </div>
        </section>
      )}
      {(currentMarket === Market.NL ||
        currentMarket === Market.BE ||
        currentMarket === Market.PL ||
        (currentMarket === Market.DE && !Model?.ForOffer)) &&
        isScheduledRepayment &&
        !isLoading && (
          <section>
            <RepaymentList
              Heading={PageData?.RepaymentPlanDetailsLabel}
              Monthlylabel={PageData?.NumberOfInstallmentsLabel}
              NumberofMonth={
                scheduledRepayment?.Model?.ConfirmScheduleFormModel
                  ?.NumberOfRegularPayments
              }
              Mothlyamount={
                scheduledRepayment?.Model?.ConfirmScheduleFormModel
                  ?.FormattedCurrencyRegularPayment
              }
              Currencysymbol={
                scheduledRepayment?.Model?.FormattedCurrencySymbol
              }
              Finallabel={PageData?.FinalPaymentLabel}
              FinalAmount={
                scheduledRepayment?.Model?.ConfirmScheduleFormModel
                  ?.FormattedCurrencyLastPayment
              }
              Totaltext={PageData?.TotalToBePaidLabel}
              Totalamount={
                scheduledRepayment?.Model?.ConfirmScheduleFormModel
                  ?.FormattedCurrencyTotalAmount
              }
            />
          </section>
        )}
      <section className="CreateRepaymentPlan__section">
        <div className="CreateRepaymentPlan__ctaWrapper button-alignment">
          <PageLink
            url={Model.BackButtonUrl}
            text={PageData.ButtonBackLabel}
            className="Button Button--gray CreateRepaymentPlan__cancelBtn"
          />
          <button
            type="submit"
            id="choose-payment-method-submit"
            className="Button CreateRepaymentPlan__confirmBtn"
          >
            {PageData?.ButtonConfirmLabel}
          </button>
        </div>
      </section>
    </form>
  );
};
export default PaymentMethodForm;
